import React, { useState, useCallback, useContext, useEffect } from "react";
import { CSVLink } from "react-csv";
import { styles } from "./styles";
import * as moment from "moment";
import { toast } from "react-toastify";
import { toastCss } from "assets/styleJS/global";
import {
  withStyles,
  createMuiTheme
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import { AuditTierHeader } from "./Headers/headers";
import Loader from "components/Loader/Loader";
import Context from "context/context";
import auditTierApi from "apis/auditTier/auditTier";
import { useHistory } from "react-router";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
// import CSVReader from 'react-csv-reader';
import ExampleCsvFile from './drive_to_thrive_sample_list.csv';
const Papa = require("papaparse/papaparse.min.js");

const GlobalCss = withStyles({
  "@global": {
    " .MuiDialog-scrollPaper": {},
    ".MuiDialog-paperWidthSm": {
      overflow: "hidden",
      maxWidth: "none",
    },
    " .MuiDialog-paper ": {},
    ".MuiFormLabel-root": {
      color: "black",
    },
  },
})(() => null);

export default function AuditTier(props) {
  const classes = styles();
  const { uploadDriveToThrive } = auditTierApi();
  const { state, dispatch } = useContext(Context);
  const history = useHistory();
  const [states, setstates] = useState({
    columns: [],
    currentYear: "",
    dialog: false,
    data: [],
    selectedFields: [],
    loading: false,
  });
  const [selectedDate, handleDateChange] = useState(new Date());
  const [selectedFile, setSelectedFile] = useState('');

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Drive To Thrive"],
    });
  }, []);

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  let selectedColumns = AuditTierHeader.map((header) => header.label);

  function handleChange(event) {
    setSelectedFile(event.target.files[0].name);
    selectedColumnFun();
    importCSV(event.target.files[0]);
  }

  function updateData(result) {
    var data = result.data;
    preparePayload(data);
  }

  function importCSV(csvFile) {
    Papa.parse(csvFile, {
      complete: updateData,
      header: true,
    });
  }

  function preparePayload(data) {
    const payload = [];
    // console.log(data.length,'raja')  
    data.forEach((value, i) => {
      // console.log(Object.values(value).length,'raja')      
      let rowData = {};
      AuditTierHeader.forEach((header,j) => {
        rowData[header.key] = Object.values(value)[j];
      });
      // console.log(rowData,'raja')
      payload.push(rowData);
      
    });
    if (payload.length === 0) {
      toast.error("*Please import csv file", {
        ...toastCss,
        autoClose: 5000,
      });
      document.getElementById("demo").value = null;
    }
    setStates({ data: payload });
  }

  const handleUploadDriveToThrive = async () => {
    try {
      let values = {
        data: states.data,
        date: selectedDate,
      };
      setStates({ loading: true });
      console.log(values)
      let res = await uploadDriveToThrive(values);
      setStates({ loading: false });
      if (res.type === "success" && res.valid) {
        setStates({ dialog: false });
        return history.push("/dashboard/upload-success", {
          type: "Data uploaded to our system successfully.",
        });
      } 
      else if (res.type === "success" && res.invalid) {
        return history.push("/dashboard/invalid-import-data", {
          obj: {
            data: res.invalidData,
            uploadedCount: res.uploadedCount,
            invalidCount: res.invalidCount,
          },
        });
      }
    } 
    catch (err) {
      setStates({ loading: false });
      console.log(err);
    }
  };

  function selectedColumnFun() {
    {
      setStates({ data: [] });
      let data = [];
      AuditTierHeader.map((header, i) => {
        if (selectedColumns?.includes(header.label)) {
          data = [...data, header.key];
          return;
        }
      });
      setStates({ selectedFields: data });
    }
  }

  return (
    <React.Fragment>
      <GlobalCss />      
      <div>
        <Grid container spacing={0}>          
          <Grid
            item
            xs={12}
            style={{ textAlign: "center", fontSize: 20, padding: 10 }}
          >
            <span style={{ fontWeight: "bold" }}>
              {" "}
              Import Drive To Thrive Data
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ textAlign: "right", fontSize: 18, padding: 10 }}
          >
            <span style={{ fontWeight: "bold" }}>Import Date : </span>
            <span>{moment(new Date()).format("YYYY-MM-DD")}</span>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ textAlign: "left", fontSize: 12, padding: 10 }}
          >
            <span style={{ fontWeight: "normal" }}>
              * Please import csv file (
                <Link
                  href={ExampleCsvFile}
                  download="drive_to_thrive_sample_list"
                  target="_blank"
                >
                  Click here to download sample .csv file
                </Link>
              )
            </span>
          </Grid>
          {states.data && states.data.length > 0 ? (
            <Grid
              item
              xs={6}
              style={{ textAlign: "right", fontSize: 14, padding: 10 }}
            >
              <span style={{ fontWeight: "normal" }}>
                {" "}
                Total Count : {states.data.length}
              </span>
            </Grid>
          ) : (
            ""
          )}
        </Grid>        
      </div>
      <Grid container spacing={0}>
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          className={classes.headingText2Grid}
        >
          <div className={classes.gridContainer}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} >
              <DatePicker
                format="yyyy/MM/dd"
                maxDate={new Date()}
                value={selectedDate}
                onChange={handleDateChange}
              />
            </MuiPickersUtilsProvider>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          className={classes.headingText2Grid}
        >
          <div>
            <input
              id="demo"
              type="file"
              accept=".csv"
              placeholder="import csv"
              onChange={handleChange}
            />
          </div>
        </Grid>
      </Grid>
      {<Loader Loading={states?.loading}></Loader>}
      {states.data && states.data.length > 0 && (
        <Grid container spacing={0}>
          <Grid item xs={12} style={{ padding: 20, textAlign: "center" }}>
            <Button
              className={
                states?.loading ? classes.uploadBtnDisabled : classes.uploadBtn
              }
              onClick={handleUploadDriveToThrive}
              disabled={states?.loading}
            >
              Upload
            </Button>
            <Button
              className={classes.previewBtn}
              onClick={() => {
                setStates({
                  dialog: false,
                  data: [],
                });
                document.getElementById("demo").value = null;
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      )}
      
    </React.Fragment>
  );
}
